<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $tc("message.mobile.prestataire", 2) }}
          </h3>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <b-container>
            <b-row>
              <b-col col sm="12">
                <vue-good-table
                  id="operation"
                  :columns="comptableColumns"
                  :rows="comptableRows"
                  :search-options="{
                    enabled: true,
                  }"
                  :pagination-options="paginationOptions"
                />
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "Accountants",
  computed: {
    ...mapGetters([
      "file",
      "hasAdminRole",
      "hasMedecinControleRole",
      "hasAssistante",
      "hasPatientRole",
      "hasPraticienRole",
      "hasSouscripteurRole",
      "hasGestionnaireRole",
      "prestataires",
    ]),

    can: function () {
      return (
        this.hasAdminRole ||
        this.hasGestionnaireRole ||
        this.hasMedecinControleRole ||
        this.hasAssistante
      );
    },

    comptableColumns: function () {
      return [
        {
          label: this.$i18n.tc("message.name"),
          field: "name",
        },
        {
          label: this.$i18n.tc("message.telephone"),
          field: "phone",
        },
        {
          label: this.$i18n.tc("message.email"),
          field: "email",
        },
        {
          label: this.$i18n.tc("message.orderNumber"),
          field: "numero_licence",
        },
        {
          label: this.$i18n.tc("message.countries"),
          field: "pays",
        },
        {
          label: this.$i18n.tc("message.city"),
          field: "ville",
        },
        {
          label: this.$i18n.tc("message.profession"),
          field: "profession",
        },
        {
          label: this.$i18n.tc("message.specialty"),
          field: "specialty",
        },
      ];
    },

    comptableRows: function () {
      let cArray = [];

      _.forEach(this.prestataires, function (user) {
        if (!_.isNull(user)) {
          let surname = user.surname == null ? "" : user.surname;
          let nomComplet =
            user.name + " " + surname.charAt(0) + surname.substring(1);
          cArray.push({
            name: nomComplet,
            phone: user.phone,
            email: user.email,
            numero_licence: user.numero_licence,
            pays: user.localisation.pays,
            ville: user.localisation.ville,
            profession: user.profession,
            specialty: user.specialites_prestataire
              .map((specialite) => specialite.libelle)
              .join(","),
          });
        }
      });
      return cArray;
    },
  },
  data() {
    return {
      paginationOptions: {
        enabled: true,
        mode: "records",
        perPageDropdown: [3, 6, 10],
      },
    };
  },
  methods: {
    getPrestataires() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };

      this.$store.dispatch("getPrestataires", { args: args });
    },

    onComptableClick(params) {
      this.$router.push({
        name: "accountant",
        params: { accountant: params.row.slug },
      });
    },
  },
  mounted() {
    this.getPrestataires();
  },
};
</script>

<style scoped></style>
